export enum PermissionError {
  MICROPHONE_PERMISSION_WAS_DENIED = 'Parece que rechazaste el permiso para usar el micrófono. Si quieres grabar audio, solo tienes que activarlo cuando el navegador te lo pida',
  MICROPHONE_PERMISSION_DENIED = 'No podemos acceder al micrófono porque el permiso fue desactivado antes. Si quieres grabar audio, necesitas activarlo desde la configuración del navegador',
}
